export default __webpack_public_path__ + "static/media/hero-room.65ff1434.jpg";